<template>
	<div>
		<div class="page-bg">
			<div class="logo">
				<img src="../assets/logo.png" alt="" />
			</div>
			<div class="btn-back  fcc" @click="back()">返回</div>
			<div class="checkin-page">
				<div class="title-bar fcc">
					<span class="checkin-title">{{ titleMap[type] }}</span>
				</div>
				<div class="checkin-list">
					<div class="item" v-for="(item, index) in checkConfig[type]" @click="checkIn(item)"
						:class="{ on: item.isCheck }">
						<div class="img">
							<img v-if="item.isCheck" src="../assets/qd2.png" alt="" srcset="" />
							<img v-else src="../assets/qd1.png" alt="" srcset="" />
						</div>
						<div class="p">
							<span>{{ item.taskName }}</span>
						</div>
					</div>
					<!-- <div class="item" @click="checkIn">
						<div class="img">
							<img src="../assets/qd1.png" alt="" srcset="" />
						</div>
						<div class="p">
							<span>7月3日上午</span>
						</div>
					</div> -->
				</div>
			</div>
		</div>
		<van-overlay :show="showcheckInBox" z-index="999" @click="showcheckInBox = false"
			@touchstart="handleTouchStart">
			<div class="fcc-h checkin-pop" style="height: 100vh;">
				<div class="fcc-h" style="width:90%;height: 45vh;" @click.stop>
					<div class="logo-wrap fcc">
						<div class="img fcc">
							<img src="../assets/logoicon.png" alt="" srcset="" />
						</div>
					</div>
					<div class="p fcc">
						请在屏幕上盖章
					</div>
					<div class="input-row fcc">
						<div class="input fcc" @click="showPwdDialog = true">
							<input type="text" placeholder="无法识别，请输入口令" readonly />
						</div>
					</div>
				</div>
			</div>
		</van-overlay>

		<div style="position:fixed;left: 110%;top: 110%;width: 0;height: 0;overflow: hidden">
			<!--      <video src="@/assets/audio/duang.mp3"  ref="audio"  controls></video>-->
			<audio id="audioID" ref="audio" class="aud">
				<source src="http://cscec.warnny.com/duang.mp3" type="audio/mp3" />
			</audio>
		</div>

		<van-overlay :show="showLoading">
			<div class="fcc-h " style="height: 100vh;">
				<van-loading size="24px" vertical color="#fff">加载中...</van-loading>
			</div>
		</van-overlay>


		<!-- 输入框 -->
		<van-dialog v-model="showPwdDialog" title="口令打卡" show-cancel-button @confirm="confirm" :lazy-render="false">
			<van-field v-model="pwd" rows="2" autosize autofocus placeholder="请输入口令" show-word-limit class="message" />
		</van-dialog>
	</div>
</template>

<script>
import CryptoJS from 'crypto-js'
import { check } from "@/utils/check"
import { getTasks, checkTask, gaizhang } from "@/api/api";
import { tanh } from 'core-js/core/number';

export default {

	data() {
		return {
			showPwdDialog: false,
			pwd: '',
			showcheckInBox: false,
			showLoading: false,
			type: 1,
			titleMap: {
				1: '签到打卡',
				2: '游戏打卡',
				3: '分享打卡',
				4: '大魔王任务',
				5: '课堂互动',
				6: '个人风采'
			},
			uid: 0,
			currentItem: {},
			checkConfig: {
				1: [{
					taskName: "7月2日上午8:00-9:00",
					isCheck: false
				}, {
					taskName: "7月2日下午13:30-13:58",
					isCheck: false
				}, {
					taskName: "7月3日上午8:30-8:58",
					isCheck: false
				}, {
					taskName: "7月3日下午13:30-13:58",
					isCheck: false
				}, {
					taskName: "7月4日上午8:30-8:58",
					isCheck: false
				}, {
					taskName: "7月4日下午13:30-13:58",
					isCheck: false
				}],
				2: [{
					taskName: "游戏1",
					isCheck: false
				}, {
					taskName: "游戏2",
					isCheck: false
				}],
				3: [{
					taskName: "分享1",
					isCheck: false
				}, {
					taskName: "分享2",
					isCheck: false
				}],
				4: [{
					taskName: "新员工代表",
					isCheck: false
				}, {
					taskName: "领誓言人",
					isCheck: false
				}, {
					taskName: "护旗手",
					isCheck: false
				}, {
					taskName: "音乐会表演者",
					isCheck: false
				}],
				5: [{
					taskName: "课堂参与1",
					isCheck: false
				}, {
					taskName: "课堂参与2",
					isCheck: false
				}, {
					taskName: "课堂参与3",
					isCheck: false
				}, {
					taskName: "课堂参与4",
					isCheck: false
				}, {
					taskName: "课堂参与5",
					isCheck: false
				}, {
					taskName: "课堂参与6",
					isCheck: false
				}],
				6: [{
					taskName: "趣味闯关赛参与者",
					isCheck: false
				}, {
					taskName: "羽毛球比赛参与者",
					isCheck: false
				}]
			},
			gaizhangCount: 0,
			checking: false

		};
	},
	async mounted() {
		this.uid = window.localStorage.getItem('cscec2026UserId')
		if (!this.uid) {
			this.$router.push({ path: '/' })
			return
		}
		if (this.$route.query.type) {
			this.type = this.$route.query.type
		} else {
			this.type = 1
		}
		this.getTaskList()
		this.$nextTick(() => {

			let Media = document.getElementById("audioID");
			Media.src = "http://cscec.warnny.com/duang.mp3";

			// setTimeout(()=>{
			//   that.$refs.audio.play()
			// },2000)
		})
	},
	methods: {
		confirm() {
			let that = this;
			// console.log(this.pwd)
			//时间戳
			if (that.checking) {
				return
			}
			let timestamp = new Date().getTime();
			//task.getTaskName()+task.getTimestamp()+task.getUserId()
			let request = {
				taskName: that.currentItem.taskName,
				timestamp: timestamp,
				userId: this.uid,
				command: this.pwd,
				type: this.type
			}
			let md5Result = CryptoJS.MD5(request.taskName + request.timestamp + request.userId).toString();
			console.log(md5Result)
			request.sign = md5Result
			request.method = 2
			//口令
			checkTask(request).then(res => {
				console.log("打卡结果", res)
				if (res && res.msg) {
					this.$toast(res.msg)
					that.checking = false
				} else if (res) {
					that.showcheckInBox = false
					that.$toast("打卡成功")
					document.querySelector('audio').play()
					document.getElementById("audioID").play()
					that.checking = false
					setTimeout(function () {
						that.getTaskList()
					}, 1000)
				} else {
					that.$toast("打卡失败，请重试")
					that.checking = false
				}
			}).finally(f => {
			})
		},
		getTaskList() {
			let self = this
			self.showLoading = true
			getTasks({ userId: this.uid, type: this.type }).then(res => {
				if (res && res.length > 0) {
					let typeTemp = self.checkConfig[self.type]
					for (let i = 0; i < typeTemp.length; i++) {
						for (let j = 0; j < res.length; j++) {
							if (typeTemp[i].taskName == res[j].taskName) {
								typeTemp[i].isCheck = true
							}
						}
					}
					self.checkConfig[self.type] = typeTemp
				}
			}).finally(f => {
				self.showLoading = false
			})
		},
		formatDateTime(date) {
			function padZero(num) {
				return num < 10 ? '0' + num : num;
			}

			var year = date.getFullYear();
			var month = padZero(date.getMonth() + 1); // 月份是从0开始的
			var day = padZero(date.getDate());
			var hours = padZero(date.getHours());
			var minutes = padZero(date.getMinutes());
			var seconds = padZero(date.getSeconds());

			return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
		},
		checkIn(item) {
			if (item.isCheck) {
				return
			}
			this.currentItem = item
			this.showcheckInBox = true
		},
		async handleTouchStart(event) {

			let that = this;
			console.log("event.touches.length", event.touches.length)
			if (event.touches.length != 4 && event.touches.length != 3) {
				return
			}
			let timestamp = new Date().getTime();
			console.log("-----------------------")
			// 使用示例
			var currentDateTime = new Date();
			console.log("date", this.formatDateTime(currentDateTime)); // 输出格式化的时间字符串
			// 获取触摸点的坐标
			let touchArr = []
			for (let i = 0; i < event.touches.length; i++) {
				var touchX = event.touches[i].clientX;
				var touchY = event.touches[i].clientY;
				// console.log('i', i)
				// console.log('touchX', touchX)
				// console.log('touchY', touchY)
				let touchItem = [touchX, touchY]
				touchArr.push(touchItem)
			}
			// let scope = check(touchArr)
			// console.log("盖章次数：", this.gaizhangCount)

			// console.log("盖章：", scope)
			let scope = true
			if (!scope) {
				// that.$toast("打卡失败，请重试")
				return
			}
			console.log("-----------------------")
			if (scope) {
				if (this.checking) {
					return
				}
				this.checking = true
				let dataArr = JSON.stringify(touchArr)
				console.log("dataArr", dataArr)
				this.gaizhangCount = 0
				//时间戳
				// let timestamp = new Date().getTime();
				//task.getTaskName()+task.getTimestamp()+task.getUserId()
				let request = {
					taskName: that.currentItem.taskName,
					timestamp: timestamp,
					userId: this.uid,
					type: this.type,
					array:touchArr
				}
				let md5Result = CryptoJS.MD5(request.taskName + request.timestamp + request.userId).toString();
				// console.log(md5Result)
				request.sign = md5Result
				request.method = 1
				console.log("request Params:", request)
				checkTask(request).then(res => {
					console.log("request Respnonse:", res)
					if (res && res.msg) {
						if("打卡失败，请重试" != res.msg){
							this.$toast(res.msg)
						}
						// this.$toast(res.msg)
						this.checking = false
					} else if (res) {
						that.showcheckInBox = false
						that.$toast("打卡成功")
						document.querySelector('audio').play()
						document.getElementById("audioID").play()
						this.checking = false
						setTimeout(function () {
							that.getTaskList()
						}, 1200)
					} else {
						// that.$toast("打卡失败，请重试")
						this.checking = false
					}
				}).finally(f => {
				})

			}


		}

	},
};
</script>
<style scoped lang="less">
	/deep/ .van-dialog {
		border-radius: 20px;
		overflow: hidden;
		box-shadow: 0 8px 40px rgba(0, 0, 0, 0.15);
		width: 86%;

		.van-dialog__header {
			padding: 36px 28px 16px;
			font-size: 32px;
			font-weight: 600;
			color: #1d1d1f;
			line-height: 1.3;
		}

		.van-dialog__content {
			padding: 0 28px 28px;

			.van-field {
				padding: 0;

				&::after {
					display: none;
				}

				.van-field__control {
					padding: 20px 24px;
					background: rgba(0, 0, 0, 0.04);
					border-radius: 14px;
					font-size: 26px;
					color: #1d1d1f;
					line-height: 1.5;

					&::placeholder {
						color: #86868b;
					}
				}
			}
		}

		.van-dialog__footer {
			border-top: 0.5px solid rgba(0, 0, 0, 0.08);

			.van-button {
				font-size: 24px;
				font-weight: 600;
				height: 68px;
			}

			.van-dialog__cancel {
				color: #86868b;
			}

			.van-dialog__confirm {
				color: #007AFF;
			}

			.van-button::after {
				border: none;
			}
		}
	}
</style>
